import { useEffect } from "react";

import { get } from "lodash";
import { updateAddressHomeInRedux } from "../components/Address/handlers";
import { handleSelectChangeGtm } from "../utils/handlers";

export const placeChangedCallback = ({
  dispatch,
  isEditing,
  autocomplete,
  formRef
}) => {
  const place = autocomplete.getPlace();
  const home = place.address_components.reduce(
    (acc, cur) => {
      switch (cur.types[0]) {
        case "street_number":
          acc.street = `${get(cur, "long_name", "")} ${get(
            acc,
            "street",
            ""
          )}`.trim();
          break;
        case "route":
          acc.street = `${get(acc, "street", "")} ${get(
            cur,
            "long_name",
            ""
          )}`.trim();
          break;
        case "postal_code":
          acc.zip = get(cur, "long_name", "");
          break;
        case "locality":
          acc.city = get(cur, "long_name", "");
          break;
        case "administrative_area_level_1":
          acc.state = get(cur, "short_name", "");
          break;
        default:
      }

      return acc;
    },
    { details: "", street: "", zip: "", city: "", state: "" }
  );

  // Work around to address omitted street numbers for
  // non validated streets on Google places api
  if (
    !/^\d+(\w?[-/]?\d*?\w?)\s/.test(get(home, "street", "")) &&
    place.address_components.length !== 0 &&
    formRef
  ) {
    const { address } = formRef.current.getData();
    const streetNumber = address.match(/^\d+(\w?[-/]?\d*?\w?)\s/);

    home.street = `${streetNumber[0]}${home.street}`;
  }

  updateAddressHomeInRedux({ dispatch, home });
  handleSelectChangeGtm("homeAddress", isEditing, "Auto-Address", true);
};

const useAutoAddressSetup = ({
  dispatch,
  hasDefinedAutoComplete,
  setHasDefinedAutoComplete,
  isEditing,
  formRef
}) => {
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.google &&
      !hasDefinedAutoComplete
    ) {
      try {
        const options = {
          componentRestrictions: { country: "us" },
          fields: ["address_components", "place_id"]
        };

        const input = document.getElementById("address");

        const autocomplete = new window.google.maps.places.Autocomplete(
          input,
          options
        );

        autocomplete.addListener("place_changed", () => {
          placeChangedCallback({ dispatch, isEditing, autocomplete, formRef });
        });

        setHasDefinedAutoComplete(true);
      } catch (e) {
        // TODO: Error while creating auto complete, handle this later
      }
    }
  }, [hasDefinedAutoComplete]);
};

export default useAutoAddressSetup;
